import { useState } from "react";
import { userService } from "../services";
const ContactUs = () => {
  const [form, setForm] = useState({});
  const [error, setError] = useState({});
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const handleChange = (e) =>
    setForm({ ...form, [e.target.name]: e.target.value });

  const handleSubmit = async (e) => {
    setError(false)
    setLoading(true);
    e.preventDefault();
    try {
      console.log(form);
      const contact = await userService.contactUs(form);
      setSuccess(true);
      setForm({})
      setLoading(false);
    } catch (error) {
      console.error(error);
      setLoading(false)
      setError(true)
    }
  };

  return (
    <div className="w-100 min-h-[70vh] mb-6">
    
      <form
        onSubmit={handleSubmit}
        className="">
        <h2 className="mb-8 text-gray-800 text-4xl">Contact Us</h2>
        {success && (
        <h6 className="text-green-900 block">
          Your message has been sent successfully. We will get back to you
          shortly. Thank you.
        </h6>
      )}
        {error ? (
          <h6 className="Login-error text-red-900 block">{error?.message}</h6>
        ) : null}
        <input
          type="email"
          name="email"
          placeholder="Email"
          onChange={handleChange}
          required
        />
        <input
          type="text"
          name="name"
          placeholder="Full name"
          onChange={handleChange}
          required
        />
        <input
          type="text"
          name="subject"
          placeholder="Subject"
          onChange={handleChange}
          required
        />

        <textarea
          type="text"
          name="message"
          placeholder="Message"
          onChange={handleChange}
          required
          className="p-3 px-6 m-2 h-[30vh] block mx-auto bg-gray-200 rounded-md placeholder-grey-500 w-full outline-none focus:bg-white border-2 border-gray-200 resize-none"
        />
        <button className="formSubmitBtn" type="submit" disabled={loading}>
          {loading ? "Sending..." : "Send"}
        </button>
      </form>
    </div>
  );
};

export default ContactUs;
